<div class="mx-auto max-w-6xl px-4 py-6 sm:px-5 sm:py-8">
    <div class="grid grid-cols-1 items-start gap-6 lg:grid-cols-12 lg:gap-8">
        <!-- Main checkout -->
        <div class="lg:col-span-8">
            <div
                class="overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-sm ring-1 ring-slate-900/5">
                <!-- Stepper -->
                <nav class="border-b border-slate-100 bg-slate-50/60 px-4 py-4 sm:px-6" aria-label="Fasi checkout">
                    <ol class="flex w-full items-center">
                        <li class="flex min-w-0 flex-1 items-center">
                            <button type="button"
                                class="flex min-w-0 items-center gap-2 rounded-lg px-1 py-1 text-left transition hover:bg-white/80 focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]/25 sm:gap-3"
                                (click)="setTabNumber(0)">
                                <span
                                    class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold transition sm:h-9 sm:w-9 sm:text-sm"
                                    [class.bg-[var(--primary-color)]]="tabNumber === 0"
                                    [class.text-white]="tabNumber === 0"
                                    [class.bg-slate-200]="tabNumber !== 0 && !isTabsEnabled"
                                    [class.text-slate-600]="tabNumber !== 0 && !isTabsEnabled"
                                    [class.bg-emerald-100]="tabNumber !== 0 && isTabsEnabled"
                                    [class.text-emerald-800]="tabNumber !== 0 && isTabsEnabled">
                                    <ng-container *ngIf="tabNumber > 0 && isTabsEnabled; else step1num">✓</ng-container>
                                    <ng-template #step1num>1</ng-template>
                                </span>
                                <span class="min-w-0">
                                    <span class="block truncate text-xs font-semibold text-slate-900 sm:text-sm"
                                        [class.text-[var(--primary-color)]]="tabNumber === 0">Informazioni</span>
                                    <span class="hidden text-[11px] text-slate-500 sm:block">Contatti e indirizzo</span>
                                </span>
                            </button>
                            <div class="mx-1 h-0.5 min-w-[0.5rem] flex-1 rounded-full sm:mx-2"
                                [class.bg-[var(--primary-color)]]="tabNumber > 0 && isTabsEnabled"
                                [class.bg-slate-200]="!(tabNumber > 0 && isTabsEnabled)"></div>
                        </li>
                        <li class="flex min-w-0 flex-1 items-center">
                            <button type="button"
                                class="flex min-w-0 items-center gap-2 rounded-lg px-1 py-1 text-left transition hover:bg-white/80 focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]/25 sm:gap-3"
                                [class.opacity-40]="!isTabsEnabled"
                                [class.pointer-events-none]="!isTabsEnabled"
                                (click)="isTabsEnabled && setTabNumber(1)">
                                <span
                                    class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold transition sm:h-9 sm:w-9 sm:text-sm"
                                    [class.bg-[var(--primary-color)]]="tabNumber === 1"
                                    [class.text-white]="tabNumber === 1"
                                    [class.bg-slate-200]="tabNumber < 1 || (tabNumber > 1 && !isTabsEnabled)"
                                    [class.text-slate-600]="tabNumber === 0"
                                    [class.bg-emerald-100]="tabNumber > 1 && isTabsEnabled"
                                    [class.text-emerald-800]="tabNumber > 1 && isTabsEnabled">
                                    <ng-container *ngIf="tabNumber > 1 && isTabsEnabled; else step2num">✓</ng-container>
                                    <ng-template #step2num>2</ng-template>
                                </span>
                                <span class="min-w-0">
                                    <span class="block truncate text-xs font-semibold sm:text-sm"
                                        [class.text-slate-900]="isTabsEnabled"
                                        [class.text-slate-400]="!isTabsEnabled"
                                        [class.text-[var(--primary-color)]]="tabNumber === 1">Spedizione</span>
                                    <span class="hidden text-[11px] text-slate-500 sm:block">Modalità di consegna</span>
                                </span>
                            </button>
                            <div class="mx-1 h-0.5 min-w-[0.5rem] flex-1 rounded-full sm:mx-2"
                                [class.bg-[var(--primary-color)]]="tabNumber > 1 && isTabsEnabled"
                                [class.bg-slate-200]="!(tabNumber > 1 && isTabsEnabled)"></div>
                        </li>
                        <li class="flex min-w-0 flex-none items-center">
                            <button type="button"
                                class="flex min-w-0 items-center gap-2 rounded-lg px-1 py-1 text-left transition hover:bg-white/80 focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)]/25 sm:gap-3"
                                [class.opacity-40]="!isTabsEnabled"
                                [class.pointer-events-none]="!isTabsEnabled"
                                (click)="isTabsEnabled && setTabNumber(2)">
                                <span
                                    class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold transition sm:h-9 sm:w-9 sm:text-sm"
                                    [class.bg-[var(--primary-color)]]="tabNumber === 2"
                                    [class.text-white]="tabNumber === 2"
                                    [class.bg-slate-200]="tabNumber < 2"
                                    [class.text-slate-600]="tabNumber < 2">
                                    3
                                </span>
                                <span class="min-w-0">
                                    <span class="block truncate text-xs font-semibold sm:text-sm"
                                        [class.text-slate-900]="isTabsEnabled"
                                        [class.text-slate-400]="!isTabsEnabled"
                                        [class.text-[var(--primary-color)]]="tabNumber === 2">Pagamento</span>
                                    <span class="hidden text-[11px] text-slate-500 sm:block">Metodo e conferma</span>
                                </span>
                            </button>
                        </li>
                    </ol>
                </nav>

                <div class="px-4 py-5 sm:px-6 sm:py-6">
                    <app-checkout-details [tabNumber]="tabNumber" (increaseTabNum)="changeTabNumber()"
                        (shippingPrice)="onShippingPriceChange($event)">
                    </app-checkout-details>
                </div>
            </div>
        </div>

        <!-- Order summary -->
        <aside class="lg:col-span-4">
            <div
                class="rounded-2xl border border-slate-200/90 bg-white p-5 shadow-sm ring-1 ring-slate-900/5 lg:sticky lg:top-24">
                <h3 class="text-sm font-semibold text-slate-900">Il tuo ordine</h3>
                <p class="mt-0.5 text-xs text-slate-500">Riepilogo carrello</p>

                <ul class="mt-4 divide-y divide-slate-100">
                    <li *ngFor="let product of products" class="flex gap-3 py-3 first:pt-0">
                        <div class="relative h-14 w-14 shrink-0 overflow-hidden rounded-lg bg-slate-100 sm:h-16 sm:w-16">
                            <img [src]="product.imageUrl" [attr.alt]="product.name"
                                class="h-full w-full object-cover" />
                            <span
                                class="absolute -right-1 -top-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-slate-900/75 px-1 text-[10px] font-bold tabular-nums text-white">
                                {{ product.quantity }}
                            </span>
                        </div>
                        <div class="min-w-0 flex-1">
                            <p class="text-sm font-medium leading-snug text-slate-900">{{ product.name }}</p>
                            <p class="mt-0.5 text-sm tabular-nums text-slate-600">
                                {{ (product.price * product.quantity) | currency:'EUR':true }}
                            </p>
                        </div>
                    </li>
                </ul>

                <dl class="mt-4 space-y-2 border-t border-slate-100 pt-4 text-sm">
                    <div *ngIf="shipmentPrice" class="flex items-center justify-between gap-2 text-slate-600">
                        <dt>Spedizione</dt>
                        <dd class="tabular-nums font-medium text-slate-900">{{ shipmentPrice | currency:'EUR':true }}
                        </dd>
                    </div>
                    <div class="flex items-center justify-between gap-2 border-t border-slate-100 pt-3 text-base font-semibold text-slate-900">
                        <dt>Totale</dt>
                        <dd class="tabular-nums">{{ lastPrice(products) | currency:'EUR':true }}</dd>
                    </div>
                </dl>
                <p class="mt-3 text-xs leading-relaxed text-slate-500">
                    Incluse imposte per un ammontare di {{ getVatPrice(cartSubTotal(products)) | currency:'EUR':true }}
                </p>
            </div>
        </aside>
    </div>
</div>
